// extracted by mini-css-extract-plugin
module.exports = {"promoSection":"PromoSection_promoSection__1i9lF","promoBanner":"PromoSection_promoBanner__2VfHu","highlight":"PromoSection_highlight__2fiG4"};